import { render, staticRenderFns } from "./NewGTCCEmailComponent.vue?vue&type=template&id=68af37fb&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/src/services/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68af37fb')) {
      api.createRecord('68af37fb', component.options)
    } else {
      api.reload('68af37fb', component.options)
    }
    module.hot.accept("./NewGTCCEmailComponent.vue?vue&type=template&id=68af37fb&", function () {
      api.rerender('68af37fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Email/NewGTCCEmailComponent.vue"
export default component.exports